module.exports = {
	"version": "0.2.6",
	"revision": "7e8447457fa3f0a3793a8e2ecd006ee12ea6bdd3",
	"revisionShort": "7e84474",
	"branch": "Detatched: 7e8447457fa3f0a3793a8e2ecd006ee12ea6bdd3"
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/buildInfo.json
 ** module id = 103
 ** module chunks = 0 1
 **/